import { NgModule } from '@angular/core';
import { ChartLegendComponent } from './chart-legend.component';
import { GridLegendComponent } from './grid-legend.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [SharedModule],
    declarations: [
        ChartLegendComponent,
        GridLegendComponent
    ],
    exports: [
        ChartLegendComponent,
        GridLegendComponent
    ]
})
export class LegendModule { }
